import type { OptionItem as OptionItemType } from '@steadioTypes/dropdown';

type OptionItemProps = {
  optionItem: OptionItemType;
  onOptionClick?: (value?: string) => void;
  lgHidden?: boolean;
};

export default function OptionItem({
  optionItem,
  onOptionClick,
  lgHidden,
}: OptionItemProps) {
  const { value, description } = optionItem;

  return (
    // safari에서 button 요소에 focus가 되지 않아 li에 tabIndex, data 부여
    <li
      tabIndex={-1}
      data-option-value={value}
      className={`${lgHidden && 'lg:hidden'}`}
    >
      <Option
        description={description}
        onOptionClick={onOptionClick}
        value={value}
      />
    </li>
  );
}

type OptionProps = {
  description: React.ReactNode;
  onOptionClick?: (value?: string) => void;
  value: string;
};

const Option = ({ description, onOptionClick, value }: OptionProps) => {
  const onClick = () => onOptionClick?.(value);

  if (typeof description === 'string') {
    return (
      <button
        type="button"
        className="w-full py-[12px] px-[20px] rounded-[8px]
        text-left content_primary font_label_regular_lg surface_primary
        hover:surface_tertiary text-ellipsis overflow-hidden whitespace-nowrap"
        data-option-value={value}
        onClick={onClick}
      >
        {description}
      </button>
    );
  }

  return <>{description}</>;
};
